import { useAutoNavigate } from '@betterment/js-runtime';
import { Card, H1, Separator } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { AccountPurposeSetupBox } from './AccountPurposeSetupBox';
import { AccountSettingsForm } from './AccountSettingsForm';

import { urlBuilder } from '../../../../Shared/urlBuilder';
import { ForecasterSettingsLoadingState } from '../../../shared/components/forecaster-settings-loading-state/ForecasterSettingsLoadingState';
import { useForecasterAccountSettings } from '../../context/ForecasterAccountInputsContext';

const AccountSettingsCardView = () => {
  const navigate = useAutoNavigate();
  const accountId = useRequiredParam('accountId');
  const { data, loading } = useForecasterAccountSettings(accountId);

  if (loading && !data) return <ForecasterSettingsLoadingState />;

  const account = data?.account;

  if (!account) return null;

  if (account.__typename !== 'ManagedAccount') {
    void navigate(urlBuilder.appAccount.absolute({ accountId: account.id }));

    return null;
  }

  return (
    <>
      <AccountSettingsForm account={account} />
      <AccountPurposeSetupBox account={account} />
    </>
  );
};

export const AccountSettingsCard = () => {
  return (
    <Card css={{ display: 'flex', flexDirection: 'column', gap: 'space.300', padding: 'space.300' }}>
      <Card.Header>
        <H1 variant="title100">Account settings</H1>
      </Card.Header>
      <Separator />
      <Card.Content css={{ display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
        <ErrorBoundary fallbackType="inline">
          <AccountSettingsCardView />
        </ErrorBoundary>
      </Card.Content>
    </Card>
  );
};
